import axios from 'axios'

// API principal de Aludra
export const aludraApi = axios.create({
  baseURL: process.env.REACT_APP_ALUDRA_API_BASE_URL,
})

// API de Document Bus (legacy)
export const busApi = axios.create({
  baseURL: process.env.REACT_APP_ALUDRA_API_BASE_URL + '/documentbus',
})

// API de Document Bus
export const documentBusApi = axios.create({
  baseURL: process.env.REACT_APP_API_DOCUMENT_BUS,
})

// API de Cuart
export const cuartApi = axios.create({
  baseURL: process.env.REACT_APP_CUART_API_BASE_URL,
})

// API de Order Allocation
export const oaApi = axios.create({
  baseURL: process.env.REACT_APP_ALUDRA_API_BASE_URL,
})

// API sin headers de autenticación ni cola de refresh 401 - para endpoints públicos/no autenticados
export const publicApi = axios.create({
  baseURL: process.env.REACT_APP_ALUDRA_API_BASE_URL,
  timeout: 15000,
})
